

export const visContainerSize = state => {
    return state.vis.containerSize
}